import { applyFormatters } from '@asset-metrix/portal-ui';
import { t } from 'i18next';

import { FilterConfigDto } from '../../store/states/filterTypes';
import { formattersByType } from '../table/configToColDef';

export const getFilterFormatters = (pageFilterConfig: FilterConfigDto) => {
  const formatterType = pageFilterConfig.type;
  const formatters = formattersByType[formatterType] ?? [];
  return <TValue>(value: TValue) => {
    return applyFormatters(formatters, value, {
      trueLabel: t('app.label.true'),
      falseLabel: t('app.label.false'),
      ...pageFilterConfig.formatOptions,
    });
  };
};
